import { useEffect, useState } from "react";
import {BookingButtonViewModel} from "../BookingButton/BookingButtonViewModel.csharp";
import {BookingSearchApi} from "./BookingSearchApi";
import {useDebouncedCallback} from "use-debounce";

const api = new BookingSearchApi();

export const useBookingSearch = (query: string) => {
  const [bookingButtons, setBookingButtons] = useState<BookingButtonViewModel[]>([]);
  const [loading, setLoading] = useState(false);

  const search = useDebouncedCallback(async (query) => {
    if (query) {
      try {
        setLoading(true);
        setBookingButtons(await api.search(query));
      } finally {
        setLoading(false);
      }
    } else {
      setLoading(false);
      setBookingButtons([]);
    }
  }, 500);
  
  useEffect(() => {
    search(query);
  }, [query, search]);

  return {
    loading,
    bookingButtons,
  };
};
